module.exports = __webpack_public_path__ + "c8a38fbf180e1ba4ebedc6fe28904680.png";